import { max, isPlainObject } from 'lodash-es'

export const allowedFieldTypes = [
  'text',
  'array',
  'select',
  'dropSelect',
  'media',
  'attachment',
  'datetime',
  'number',
  'org',
  'orgMultiple',
  'user',
  'userMultiple',
  'area',
  'standard',
  'geolocation',
  'locationWithText',
  'column',
  'ref',
  'tree',
  'gis',
  'ref',
  'lookup',
  'richText',
  'product',
  'boolean',
]

export const fileterHiddenFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter((field) => {
    return field && !field.hidden
  })
}

export const fileterSystemFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter((field) => {
    return field && field.group !== 'system' && !field.hidden
  })
}

export const fileterHiddenWhenCreateFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter((field) => {
    return field && field.group !== 'system' && !field.hiddenWhenCreate
  })
}

export const showFiledValue = (data, fields, findDataSlug) => {
  if (!data) {
    return null
  }
  if (!isPlainObject(data)) {
    return data
  }
  const maxOrder = max(fields.map((field) => field.showOrder).filter((v) => v))
  const obj =
    (maxOrder && fields.find((field) => field.showOrder === maxOrder)) || {}
  const findDataField = fields.find((v) => v.slug === findDataSlug) || {}

  if (findDataField.type === 'dropSelect' || findDataField.type === 'select') {
    const { selects } = findDataField
    const _obj = selects.find((l) => {
      if (data[findDataSlug]) {
        return l.slug === data[findDataSlug] || l.slug === data[findDataSlug][0]
      }
      return false
    })

    if (_obj) {
      return _obj.title
    }
  }
  return (
    (findDataSlug && data[findDataSlug]) ||
    (obj && obj.title) ||
    data.title ||
    data.name ||
    data.label ||
    data.id ||
    data.objectId ||
    JSON.stringify(data)
  )
}

export const fieldFilter = (field) => {
  return (
    field &&
    !['system'].includes(field.group) &&
    !field.hidden &&
    (allowedFieldTypes.includes(field.type) || field.lookup)
  )
}
